import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m31.35 33.65 2.25-2.25-7.95-8V13.35h-3V24.6zM24 44q-4.1 0-7.75-1.575t-6.375-4.3-4.3-6.375T4 24t1.575-7.75 4.3-6.375q2.726-2.725 6.375-4.3T24 4t7.75 1.575 6.375 4.3 4.3 6.375Q44 19.9 44 24t-1.575 7.75-4.3 6.375-6.375 4.3T24 44m0-3q7 0 12-5t5-12-5-12-12-5-12 5-5 12 5 12 12 5" })
});
export default SvgClock;
